import React, {Component} from 'react';
import InactiveAccordion from 'go/components/modules/requestDetails/v3/renderers/InactiveAccordion';
import ActiveAccordion from 'go/components/modules/requestDetails/v3/renderers/ActiveAccordion';

export class CustomGridLayout extends Component {
  state = {
    active: this.props.expand || false,
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      active: !prevState.active,
    }));
  };

  render() {
    const {
      headerTitle,
      total,
      actualTotal,
      actualAllowedTotal,
      isValid,
      validationErrors,
      tier,
      deleteItem,
      activityKey,
      activityName,
      itemLabel,
      children,
      isNarrative,
      sourcePath,
      instructionText,
      templatedValue,
      gridLayout,
      customText,
      editable,

      deletable,
      editLabel,
      mode,
      hasChanges,
      renderChangesSection,
      newlyCreated,
    } = this.props;
    const isActive = this.state.active;
    const childWithProps = React.Children.map(children, (child) =>
      React.cloneElement(child, {handleClose: this.handleToggle})
    );
    return (
      <React.Fragment>
        {isActive ? (
          <>
          <ActiveAccordion
            tier={tier}
            isNarrative={isNarrative}
            handleToggle={this.handleToggle}
            total={total}
            actualTotal={actualTotal}
            actualAllowedTotal={actualAllowedTotal}
            headerTitle={headerTitle}
            isValid={isValid}
            validationErrors={validationErrors}
            deleteItem={deleteItem}
            activityKey={activityKey}
            activityName={activityName}
            itemLabel={itemLabel}
            sourcePath={sourcePath}
            instructionText={instructionText}
            templatedValue={templatedValue}
            gridLayout={gridLayout}
            customText={customText}
            editable={editable}

            deletable={deletable}
            editLabel={editLabel}
            mode={mode}
            newlyCreated={newlyCreated}
          >
            {childWithProps}
          </ActiveAccordion>
          {hasChanges && (
            <div
              className={`app_accordion_budget-tier1 background--info w-clearfix`}
            >
              {renderChangesSection()}
            </div>
          )}
          </>
        ) : (
          <InactiveAccordion
            tier={tier}
            isNarrative={isNarrative}
            handleToggle={this.handleToggle}
            total={total}
            actualTotal={actualTotal}
            actualAllowedTotal={actualAllowedTotal}
            headerTitle={headerTitle}
            isValid={isValid}
            sourcePath={sourcePath}
            activityName={activityName}
            templatedValue={templatedValue}
            gridLayout={gridLayout}
            editable={editable}

            editLabel={editLabel}
            mode={mode}
          />
        )}
      </React.Fragment>
    );
  }
}

export default CustomGridLayout;
